


























































import Vue from 'vue'
import { AddonEl, HeaderCarouselElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'HeaderCarouselEl',
  props: {
    templateItemData: {
      type: Object as () => HeaderCarouselElInterface,
      required: true
    }
  },
  data: () => ({
    slide: 0
  }),
  methods: {
    getTextColor (addon: AddonEl): string {
      return `color: ${addon.textColor || 'primary'};`
    }
  }
})
